import script from "./txtScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./txtScroll.vue?vue&type=script&setup=true&lang=js"

import "./txtScroll.vue?vue&type=style&index=0&id=8b5915ac&lang=less&scoped=true"
script.__scopeId = "data-v-8b5915ac"

export default script